module.exports = __webpack_public_path__ + "img/custom_problem_editor.ef33f622.jpeg";